<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-tipo-agrovisita') {
            next({ name: 'agro-tipo-agrovisita-list' });
        } else if (to.name == 'ven-tipo-agrovisita') {
            next({ name: 'ven-tipo-agrovisita-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-tipo-agrovisita') {
            this.$router.push({ name: 'agro-tipo-agrovisita-list' });
        } else if (this.$route.name == 'ven-tipo-agrovisita') {
            this.$router.push({ name: 'ven-tipo-agrovisita-list' });
        }
    },
};
</script>
